module.exports = __webpack_public_path__ + "static/media/DINPro-Medium_13936.48a3635c.ttf";